module.exports = __webpack_public_path__ + "img/18_103.c77752ce.png";